export const ROUTES = {
  // File routes
  privacyPolicy: "/privacy-policy.pdf",
  termsOfServiceCustomer: "/t-c-customer.pdf",
  termsOfServiceMerchant: "/t-c-merchant.pdf",
  // Normal routes
  root: "/",
  admin: "/admin",
  auth: "/auth",
  authConfirm: "/auth/confirm",
  loginCustomer: "/auth/login/customer",
  loginMerchant: "/auth/login/merchant",
  signupCustomer: "/auth/signup/customer",
  signupMerchant: "/auth/signup/merchant",
  error: "/error",
  customerWelcome: "/customer-welcome",
  customer: "/customer",
  customerWallet: "/customer/wallet",
  customerOrders: (orderId?: string, thankYou?: boolean) => {
    const queryString = buildQueryString({ orderId, thankYou: thankYou ? "true" : undefined })
    return `/customer/orders${queryString ? `?${queryString}` : ""}`
  },
  customerOngoingOrder: "/customer/ongoing-order",
  merchant: "/merchant",
  merchantOrders: "/merchant/orders",
  merchantWelcome: "/merchant-welcome",
  passwordReset: "/password-reset",
  updatePassword: "/update-password",
  updateEmail: "/update-email",
  explore: "/explore",
  waitlist: "/waitlist",
  merchantPublic: (id: string) => `/merchants/${id}`,
  merchantOngoingOrders: "/merchant/ongoing-orders",
  customerCodes: "/customer/codes",
  merchantRedeemer: "/merchant-redeemer",
} as const

export const API_ROUTES = {
  feedback: "/feedback",
  stripeAccountLinkReturn: "/api/stripe/account-link-return",
  customerOngoingOrder: "/api/customer/ongoing-order",
  merchantOngoingOrders: "/api/merchant/ongoing-orders",
  order: "/api/order",
  fullfilOrder: "/api/jobs/fullfil-order",
  webhooks: "/webhooks",
  // Payment method routes
  paymentMethods: "/api/payment-methods",
  paymentMethodsDefault: "/api/payment-methods/default",
  paymentMethodById: (id: string) => `/api/payment-methods/${id}`,
} as const

export const QUERY_PARAMS = {
  user_wallet: "user_wallet",
} as const

export const QUERY_KEYS = {
  customerOngoingOrder: "customer-ongoing-order",
  customerPendingOrder: "customer-pending-order",
  merchantOngoingOrders: "merchant-ongoing-orders",
  customerOrderById: (orderId: string) => `customer-order-by-id-${orderId}`,
} as const

const buildQueryString = (params: Partial<Record<string, string>>) => {
  return Object.entries(params)
    .filter(([_, value]) => value !== undefined)
    .map(([key, value]) => `${key}=${value}`)
    .join("&")
}
